import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { IRootReducerState } from 'state/rootReducer'
import { Grid, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import Store from '@mui/icons-material/Store'
import AccountCircle from '@mui/icons-material/AccountCircle'
import HelpOutline from '@mui/icons-material/HelpOutline'
import { IShop } from '@cbgms/api/modules/shops'
import { IEmployee } from '@cbgms/api/modules/employees'
import FullName from '@cbgms/components/src/utils/FullName'
import FullShop from 'core/utils/FullShop'
import { RequiredPermission } from 'utils/Subscription/RequiredPermissions'
import { PERMISSION_CLOCKINGACTIONS_DAY, PERMISSION_CLOCKINGACTIONS_READ } from 'utils/Subscription/Permissions'
import Clock from './TopBar/Clock'
import MessagesMenu from 'app/menu/components/TopBarV1/Messages'
import { TopBarMenuItem } from 'app/menu/components/TopBarV1/TopBarMenuItem'
import { TimeRegistrationMenu } from 'app/menu/components/TopBarV1/TimeRegistration'
import { CarsysAppBar, CarsysAppBarProps } from 'app/menu/components/TopBar/AppBar'

interface Props extends CarsysAppBarProps {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuSection: {
      display: 'flex',
      alignItems: 'center'
    },
    menuItem: {
      padding: theme.spacing(1, 2),
      display: 'flex',
      alignItems: 'center'
    },
    menuItemIcon: {
      marginRight: theme.spacing(1)
    }
  })
)

const TopIFrame: React.FC<Props> = props => {
  const classes = useStyles()
  const { t } = useTranslation()
  const history = useHistory()

  const employee = useSelector<IRootReducerState, IEmployee>(state => state.auth.employee)
  const shop = useSelector<IRootReducerState, IShop>(state => state.auth.shop)

  return (
    <CarsysAppBar {...props}>
      <Grid container justifyContent='space-between'>
        <Grid item className={classes.menuSection}>
          <Clock />
        </Grid>
        <Grid item className={classes.menuSection}>
          <RequiredPermission permission={[PERMISSION_CLOCKINGACTIONS_READ, PERMISSION_CLOCKINGACTIONS_DAY]}>
            <TimeRegistrationMenu />
          </RequiredPermission>
          <MessagesMenu />
          <Grid item className={classes.menuItem}>
            <Store className={classes.menuItemIcon} />
            <FullShop shopID={shop.ID} shopName={shop.Name} shopCity={shop.VisitorCity} />
          </Grid>
          <Grid item className={classes.menuItem}>
            <AccountCircle className={classes.menuItemIcon} />
            <FullName firstName={employee.FirstName} prefix={employee.NamePrefix} lastName={employee.Name} />
          </Grid>
          <TopBarMenuItem onClick={() => history.push('/contact')} badge={0} startIcon={<HelpOutline />}>
            {t('Contact.Title')}
          </TopBarMenuItem>
        </Grid>
      </Grid>
    </CarsysAppBar>
  )
}

export default TopIFrame
